import styled, { keyframes } from 'styled-components';
import { commonStyles } from '../../theme';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.padding || '20px 0'};
  ${props => props.fullScreen && `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${commonStyles.primaryBackground};
    z-index: 999;
  `}
`;

const Spinner = styled.div`
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;
  border: 3px solid ${commonStyles.primaryBorder};
  border-top: 3px solid ${commonStyles.buttonPrimary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingSpinner = ({ size = 24, padding = '20px 0', fullScreen = false }) => {
  return (
    <SpinnerContainer padding={padding} fullScreen={fullScreen}>
      <Spinner size={size} />
    </SpinnerContainer>
  );
};

export default LoadingSpinner;